var _rect, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastestWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 48,
    height: 28,
    rx: 6,
    fill: "#00C853"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 48,
    height: 6,
    fill: "#2E7D32"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32,10 26,26 34,26 28,42 42,22 34,22",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastestWithdrawal);
export default __webpack_public_path__ + "static/media/fastest_withdrawal.596c9e4c674ad184ad3525a21047e08a.svg";
export { ForwardRef as ReactComponent };